import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, ArrowUpRight } from "lucide-react";
import Logo from "./Logo";
import { BUSINESS, SERVICES } from "../data/site";

export default function Footer() {
  return (
    <footer className="border-t border-white/10 bg-coal">
      <div className="mx-auto max-w-7xl px-5 sm:px-8 py-16 grid gap-12 md:grid-cols-2 lg:grid-cols-4">
        <div>
          <Logo />
          <p className="mt-5 text-sm text-muted leading-relaxed max-w-xs">
            Luxury mobile & in-shop auto detailing in Sioux Falls, South Dakota —
            from full interior details to certified System X ceramic coatings.
          </p>
        </div>

        <div data-testid="footer-services">
          <p className="font-mono text-[11px] uppercase tracking-widest text-bright mb-4">Services</p>
          <ul className="space-y-2.5">
            {SERVICES.map((s) => (
              <li key={s.path}>
                <Link to={s.path} className="text-sm text-steel hover:text-white transition-colors">
                  {s.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div data-testid="footer-company">
          <p className="font-mono text-[11px] uppercase tracking-widest text-bright mb-4">Studio</p>
          <ul className="space-y-2.5">
            <li><Link to="/pricing" className="text-sm text-steel hover:text-white transition-colors">Pricing & Packages</Link></li>
            <li><Link to="/book" className="text-sm text-steel hover:text-white transition-colors">Book a Detail</Link></li>
            <li><Link to="/book" className="text-sm text-steel hover:text-white transition-colors">Free Quote Request</Link></li>
          </ul>
        </div>

        <div data-testid="footer-contact">
          <p className="font-mono text-[11px] uppercase tracking-widest text-bright mb-4">Contact</p>
          <ul className="space-y-3.5 text-sm">
            <li>
              <a href={BUSINESS.phoneHref} data-testid="footer-phone-link" className="flex items-center gap-2.5 text-white hover:text-bright transition-colors">
                <Phone size={15} className="text-bright" /> {BUSINESS.phone}
              </a>
            </li>
            <li>
              <a href={`mailto:${BUSINESS.email}`} className="flex items-center gap-2.5 text-steel hover:text-white transition-colors break-all">
                <Mail size={15} className="text-bright shrink-0" /> {BUSINESS.email}
              </a>
            </li>
            <li className="flex items-start gap-2.5 text-steel">
              <MapPin size={15} className="text-bright shrink-0 mt-0.5" />
              <span>{BUSINESS.street}<br />{BUSINESS.city}, {BUSINESS.region} {BUSINESS.zip}</span>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/5">
        <div className="mx-auto max-w-7xl px-5 sm:px-8 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-muted">© {new Date().getFullYear()} A+ Detailing · Sioux Falls, SD</p>
          <a
            href="https://www.aplusdetailing.info"
            className="text-xs text-muted hover:text-bright transition-colors inline-flex items-center gap-1"
          >
            aplusdetailing.info <ArrowUpRight size={12} />
          </a>
        </div>
      </div>
    </footer>
  );
}
